module.exports = __webpack_public_path__ + "static/media/security.e9998f13.svg";